import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { SessionProvider, useSession } from "@/auth/session";
import { ForcePasswordChange } from "@/auth/force-password-change";

/**
 * Corta el paso a quien todavia usa la clave temporal del alta.
 *
 * Va sobre las rutas y no dentro de un guard, para que no se pueda evitar
 * navegando directo a otra direccion.
 */
function PasswordGate({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, session } = useSession();
  if (isAuthenticated && session?.mustChangePassword) {
    return <ForcePasswordChange />;
  }
  return <>{children}</>;
}

function App() {
  return (
    <SessionProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={__BASE_PATH__}>
          <PasswordGate>
            <AppRoutes />
          </PasswordGate>
        </BrowserRouter>
      </I18nextProvider>
    </SessionProvider>
  );
}

export default App;
